import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { PatientService } from '@app/_services';
import { Router } from '@angular/router';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private patientService: PatientService,private spinner : NgxSpinnerService,private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if ([401, 403].includes(err.status) && this.patientService.patientInfo) {
                this.patientService.logout();
                this.router.navigate(['account/login']);
                this.spinner.hide();
            }

            const error = err.error?.message || err.statusText;
            return throwError(error);
        }))
    }
}